interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/1a62d479ea6bd5856073579187b5ee28/2273754ace4baa99a36af6ba784ae686.png" 
              alt="Fortaleza Music & Mariachi School" 
              className="h-12 w-auto object-contain"
            />
            <span className={`font-semibold text-lg transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              Fortaleza Music
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`transition-colors hover:text-[#D2691E] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`transition-colors hover:text-[#D2691E] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('programs')}
              className={`transition-colors hover:text-[#D2691E] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Programas
            </button>
            <button
              onClick={() => scrollToSection('schedule')}
              className={`transition-colors hover:text-[#D2691E] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Horarios
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className={`transition-colors hover:text-[#D2691E] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Beneficios
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#D2691E] text-white px-6 py-2.5 rounded-full hover:bg-[#B8571A] transition-all shadow-md whitespace-nowrap"
            >
              Contacto
            </button>
          </div>

          <button className="md:hidden">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
